/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import ICONS from "../../../../../assets/Icons";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import globalText from "../../../../../utils/globalText";
import BankDetails from "../../../../_utils/AccountCreationComponents/BankDetails";
import ConfirmBtnAccCreation from "../../../../_utils/AccountCreationComponents/ConfirmBtnAccCreation";
import ActiveInactiveAssociatePopup from "../../../../_utils/ActiveInactiveAssociatePopup";
import CommonAlertCard from "../../../../_utils/CommonAlertCard";
import CommonLayout from "../../../../_utils/CommonLayout";
import ConfidentialCard from "../../../../_utils/TransactionCommonComponents/ConfidentialCard";
import "./index.css";

const BeneficiaryAccountStepBank = ({
  bankLookupNext,
  setBankLookupNext,
  activeStep,
  payload,
  setPayload,
  setBankUserInfo,
  bankVerificationStatus,
  setBankVerificationStatus,
  isIFSCValid,
  bankLookupError,
  virtualAccount,
  setVirtualAccount,
  isBankLinkedAccount,
  setManualVirtualAccount,
  manualVirtualAccount,
  ifscDetailsError,
  ifscData,
  ifscDetailsLoading,
  accountActiveInactiveState,
  setAccountActiveInactiveState,
  currentAssociate,
  setCurrentAssociate,
  openAssociatePopup,
  setOpenAssociatePopup,
  shouldDisableBankConfirm,
  isIconGrey,
  bankLookupData,
  setIsNextButtonEnabled,
  verifyBankAccountError,
  bankLookupLoading,
  verifyBankAccountLoading,
  showManualVirtualToggle,
}) => {
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    if (
      !bankLookupLoading &&
      !verifyBankAccountLoading &&
      !bankLookupData?.beneficiary_accounts?.length &&
      !verifyBankAccountError &&
      isIFSCValid &&
      bankLookupError === true
    ) {
      setShowDetails(true);
    } else {
      setShowDetails(false);
    }
  }, [
    bankLookupLoading,
    verifyBankAccountLoading,
    bankLookupData,
    bankLookupError,
    verifyBankAccountError,
  ]);

  return (
    <>
      <div className="flex flex-col Qsmd:flex-row px-padding-md lg:px-padding-base py-padding-md Qsmd:py-padding-base Qsmd:gap-gap-xl max-w-tab-width-normal w-full mx-auto gap-gap-md">
        <CommonLayout>
          <div className="w-width-full flex flex-col gap-gap-md">
            {isBankLinkedAccount && isIFSCValid && (
              <CommonAlertCard
                texts={`The bank account is already linked to the provided PAN. To proceed, update either the bank details or the PAN associated with the account.`}
              />
            )}
            {virtualAccount && isIFSCValid && (
              <CommonAlertCard
                title="Virtual Account Detected"
                texts={[
                  "Account could not be verified as it is a virtual account.",
                  "Self verify and proceed with caution.",
                ]}
                icon={ICONS?.VIRTUAL_ACCOUNT}
              />
            )}

            <div className="w-width-full h-fit lg:max-w-[var(--create-box-width)] Qsmd:!pb-padding-md">
              <BankDetails
                payload={payload}
                setPayload={setPayload}
                BenEnableNextButton={setIsNextButtonEnabled}
                activeStep={activeStep}
                setVirtualAccount={setVirtualAccount}
                setBankUserInfo={setBankUserInfo}
                setShowAccInfo={(e) => {}}
                bankLookupNext={bankLookupNext}
                setBankLookupNext={setBankLookupNext}
                bankVerificationStatus={bankVerificationStatus}
                setBankVerificationStatus={setBankVerificationStatus}
                isIFSCValid={isIFSCValid}
                manualVirtualAccount={manualVirtualAccount}
                setManualVirtualAccount={setManualVirtualAccount}
                ifscData={ifscData}
                ownerAccIfscError={ifscDetailsError}
                ownerAccIfscLoading={ifscDetailsLoading}
              />
            </div>
          </div>

          <div className="w-width-full flex flex-col lg:max-w-[var(--create-box-width)] pb-padding-md">
            {showManualVirtualToggle && (
              <ConfidentialCard
                icon={ICONS.VIRTUAL_ACCOUNT}
                title={globalText?.MARK_VIRTUAL_ACCOUNT}
                note={globalText?.VIRTUAL_ACCOUNT_NOTE}
                toggleState={manualVirtualAccount}
                onToggle={() => {
                  if (!isIFSCValid || ifscDetailsError || ifscDetailsLoading) {
                    return;
                  }
                  const nextState = !manualVirtualAccount;
                  setManualVirtualAccount(nextState);
                  setBankVerificationStatus(!bankVerificationStatus);
                  setPayload((prev) => ({
                    ...prev,
                    virtual: nextState,
                  }));
                }}
              />
            )}

            {bankLookupLoading === false &&
              ifscDetailsLoading === false &&
              verifyBankAccountLoading === false &&
              !(isBankLinkedAccount && isIFSCValid) && (
                <div style={{ overflow: "hidden" }}>
                  <div
                    className={
                      !(isBankLinkedAccount && isIFSCValid)
                        ? "animate-slideInFromRight"
                        : ""
                    }
                  >
                    <ConfirmBtnAccCreation
                      type="bank"
                      status={
                        bankLookupData?.beneficiary_accounts?.length >
                        GlobalConfiguration.lengthCheckZero
                      }
                      isIFSCValid={isIFSCValid}
                      isBankError={bankLookupError}
                      lookupNext={!shouldDisableBankConfirm && bankLookupNext}
                      isButtonDisabled={shouldDisableBankConfirm}
                      nextButtonEnabled={isIconGrey}
                      handleClick={() => {
                        if (shouldDisableBankConfirm) return;
                        setBankLookupNext(true);
                      }}
                    />
                  </div>
                </div>
              )}
            <div>
              <ActiveInactiveAssociatePopup
                flow={
                  verifyBankAccountError === true
                    ? "hideAssociate"
                    : isBankLinkedAccount && isIFSCValid
                      ? "Existing"
                      : showDetails
                        ? "notFoundBank"
                        : !showDetails &&
                            bankLookupData?.beneficiary_accounts?.length
                          ? "Bank"
                          : "defaultBank"
                }
                dropDownNo={GlobalConfiguration?.lengthCheckZero}
                ifsc={payload?.ifsc_code}
                bank={payload?.bank_account}
                pan={payload?.panNumber}
                accActiveInactiveState={accountActiveInactiveState}
                setAccActiveInactiveState={setAccountActiveInactiveState}
                currentAssociate={currentAssociate}
                setCurrentAssociate={setCurrentAssociate}
                openAssociatePopup={openAssociatePopup}
                setOpenAssociatePopup={setOpenAssociatePopup}
                currentRoute={"beneAccount"}
                ifscLength={payload?.ifsc_code?.length}
              />
            </div>
          </div>
        </CommonLayout>
      </div>
    </>
  );
};
export default BeneficiaryAccountStepBank;
